exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3_YY1sLVeh6mGJ8azu3wth{width:280px;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"dialog": "_3_YY1sLVeh6mGJ8azu3wth"
};